<div class="hb-container hb-container--width-lg">
  <div class="hb-tekstgruppe hb-tekstgruppe--optimal-linjelengde">
    <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Slik bruker du statistikk&shy;banken</h1>
    <p class="hb-avstand--gruppe">I tillegg til denne hjelpesiden, finner du hjelpetekster og forklaringer til data i grafene inne på de ulike virkemiddelsidene.</p>
    <p class="hb-screenreader-only">For skjermleser vil alle grafer leses opp som tabelldata.</p>
    <div class="hb-panel hb-panel--hvit">
      <h2 class="hb-h2">1. Slik finner du fram</h2>
      <img src="../../../assets/images/hjelp-nav-ny.png" aria-hidden="true" alt="Skjermbilde av hvor du finner de ulike virkemidlene" class="width100 hb-mb--md" />
      <p>Velg virkemiddel fra oversikt-siden eller fra toppmenyen.</p>
    </div>
    <div class="hb-panel hb-panel--hvit">
      <h2 class="hb-h2">2. Velg ønskede filtre på siden:</h2>
      <img src="../../../assets/images/hjelp-filter-ny.png" aria-hidden="true" alt="Skjermbilde av hvor du finner filtrering av alternativer" class="width100 hb-mb--md" />
      <p>
        Det finnes mange filtreringsmuligheter på virkemiddelsidene. Valgte filtre vises i venstremeny under overskriften "valgte filter". De fleste filtre kan du fjerne ved å
        klikke på "Nullstill"-knappen.
      </p>
    </div>
    <div class="hb-panel hb-panel--hvit">
      <h2 class="hb-h2">3. Filtre som ikke er relevante eller har 0 treff:</h2>
      <img
        src="../../../assets/images/hjelp-tom-umulig-ny.png"
        aria-hidden="true"
        alt="Skjermbilde av filtre som ikke har treff eller ikke er relevante"
        class="width100 hb-mb--md"
      />
      <p>Dersom et filter ikke er relevant for datautvalget, vil det ikke være synlig. Dersom et filter vil gi deg 0 i treff, vil det vises, men ikke være valgbart.</p>
    </div>
    <div class="hb-panel hb-panel--hvit">
      <h2 class="hb-h2">4. Filtre internt i grafen:</h2>
      <img src="../../../assets/images/hjelp-graf-filter.png" aria-hidden="true" alt="Skjermbilde av filtrering i grafen" class="width100 hb-mb--md" />
      <p>
        Selve grafen har interne filterunksjoner som beskrevet i figuren. Klikk inne i grafen for å aktivere de interne funksjonene. <br />
        Legg merke til scrollbaren som kommer til syne for grafer med mye innhold.
      </p>
    </div>
    <div class="hb-panel hb-panel--hvit">
      <h2 class="hb-h2">5. Andre funksjoner i grafen:</h2>
      <img src="../../../assets/images/hjelp-cardmeny-ny.png" aria-hidden="true" alt="Skjermbilde av andre funksjoner i grafen" class="width100 hb-mb--md" />
      <p>
        Under grafen finnes mulighet for å eksportere tallene til excel. Her finner du også mer informasjon om dataene i grafen.<br />
        I tillegg er det mulig å vise grafen som tabell.
      </p>
    </div>
  </div>
</div>
